import { Injectable } from '@angular/core';
import * as sentry from '@sentry/angular';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler extends sentry.SentryErrorHandler {
  private lastAttemptedNavigation: string | null = null;

  constructor(
    private router: Router,
    sentryOptions?: sentry.ErrorHandlerOptions
  ) {
    super(sentryOptions);

    this.router.events
      .pipe(
        takeUntilDestroyed(),
        filter((event) => event instanceof NavigationStart)
      )
      .subscribe((event: NavigationStart) => (this.lastAttemptedNavigation = event.url));
  }

  handleError(error): void {
    console.error(error);
    /* eslint-disable no-useless-escape */
    const tmpDeploymentUrlPattern =
      /^Failed to fetch dynamically imported module: (?:https?:\/\/)?(?:[^\/@.]+\.)*tmp\.ops\.twaice\.ai(?:\/.*)?$/;
    const deploymentUrlPattern =
      /^Failed to fetch dynamically imported module: (?:https?:\/\/)?(?:[^\/@.]+\.)*twaice\.cloud(?:\/.*)?$/;
    /* eslint-enable no-useless-escape */

    if (tmpDeploymentUrlPattern.test(error.message) || deploymentUrlPattern.test(error.message)) {
      this.reloadPage();
      return;
    }

    super.handleError(error);
  }

  private reloadPage() {
    if (this.lastAttemptedNavigation) {
      const [pathname, search] = this.lastAttemptedNavigation.split('?');
      const redirectTo = `${pathname}${search ? `?${search}` : ''}`;
      localStorage.setItem('redirectTo', redirectTo);
    }

    window.location.reload();
  }
}
